import React from 'react'
import type { IconType } from 'react-icons'

interface Props {
  icon: IconType
  size: number
  color: string
}

const RIcon: React.FC<Props> = ({ icon, size, color }) => {
  const I = icon as React.ComponentType<{ size: number; color: string }>
  return <I size={size} color={color} />
}

export default RIcon
